import { useState } from 'react'
import { AuthCard } from './AuthCard'
import { AuthInput } from './AuthInput'
import { AuthButton } from './AuthButton'
import { Lock, Send, ArrowLeft } from 'lucide-react'
import { AuthState } from '@/hooks/useCustomAuth'

interface ForgotPasswordFormProps {
  authState: any
  handleForgotPassword: (email: string) => Promise<any>
  changeState: (newState: AuthState, tempEmail?: string, fromLogin?: boolean) => void
}

export function ForgotPasswordForm({
  authState,
  handleForgotPassword,
  changeState
}: ForgotPasswordFormProps) {
  const [email, setEmail] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!email) {
      return
    }

    try {
      const result = await handleForgotPassword(email)

      if (result?.success) {
        // The hook will change the state to confirmResetPassword
      }
    } catch (error) {
      console.error('❌ Forgot password error:', error)
    }
  }

  return (
    <AuthCard
      title="Recuperar senha"
      subtitle="Digite seu e-mail para receber o código de recuperação"
      icon={<Lock className="h-8 w-8 text-brand-dark" />}
    >
      <form onSubmit={handleSubmit} className="space-y-6" data-testid="forgot-password-form">
        <AuthInput
          label="E-mail"
          type="email"
          value={email}
          onChange={setEmail}
          placeholder="seu.email@monumenta.com.br"
          required
          error={authState.error?.code === 'UserNotFoundException' ? authState.error.message : undefined}
          data-testid="forgot-password-email-input"
        />

        {authState.error && authState.error.code !== 'UserNotFoundException' && (
          <div
            className="bg-error/20 border border-error text-error px-4 py-3 rounded-monumenta text-sm"
            data-testid="forgot-password-error-message"
          >
            {authState.error.message}
          </div>
        )}

        <AuthButton
          type="submit"
          variant="primary"
          loading={authState.isLoading}
          disabled={!email}
          className="w-full"
          icon={<Send className="h-5 w-5" />}
          data-testid="forgot-password-submit-button"
        >
          Enviar código
        </AuthButton>

        <AuthButton
          variant="ghost"
          onClick={() => changeState('signIn')}
          className="w-full"
          icon={<ArrowLeft className="h-4 w-4" />}
          data-testid="forgot-password-back-button"
        >
          Voltar ao login
        </AuthButton>
      </form>
    </AuthCard>
  )
}